import React from 'react'
import ButtonComponent from '../../atoms/Button/Button'
import { useNavigate } from 'react-router-dom'

const AndroidConceptBox = () => {
    const navigate = useNavigate()
    return (
        <div>
            <div className='border-t-8 border-yellow mx-4 sm:mx-8 md:mx-12'></div>
            <div className='bg-blackDarkThemePrimary text-center p-6 sm:p-10 md:p-16 w-full flex flex-col items-center justify-center'>
                <div className='text-xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4'>Kick off your Android App development now</div>
                <div className='text-base sm:text-lg md:text-xl leading-6 sm:leading-7 md:leading-8 text-[#FFFFFFCC] mb-4 md:mb-5 px-2'>
                    Our talented team is set to convert your concepts into a quality
                    <span className="hidden sm:inline"><br /></span> Android app that will make your business grow.
                </div>
                <ButtonComponent
                    onClick={() => { navigate('/contactus') }}
                    labelClassname="text-sm sm:text-base font-medium text-white"
                    inputStyles={{
                        background: 'var(--color-primary)',
                        color: "black",
                        padding: window.innerWidth < 640 ? '10px 1.5rem' : window.innerWidth < 768 ? '12px 2rem' : '15px 3rem',
                        boxShadow: 'none',
                        borderRadius: '10px'
                    }}
                    label={'Enquire to build your Android app'} />
            </div>
            <div className='border-b-8 border-yellow mx-4 sm:mx-8 md:mx-12'></div>
        </div>
    )
}

export default AndroidConceptBox
